export const styles = theme => ({
  root : {
    width : '100%',
    height : '100%',
  },
  listItem : {
    height : '100%',
    boxShadow :'0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);',
    position : 'relative',
  },
  imageItem: {
      cursor: 'pointer',
      minHeight: '5rem',
      width: '100%',
      objectFit: 'contain', 
      backgroundSize : 'contain',
      backgroundPosition : 'center',
      backgroundRepeat: 'no-repeat',
      [theme.breakpoints.up('lg')]: {
        minHeight: '8rem',
      },
      '& img': {
        width : '100%',
        height : '100%',
      }
  },
  inputImage : {
      display : 'none'
  },
  buttonIcon : {
      width : 64,
      height : 64,       
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
  },
  icon: {
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    fontSize: 40,
  },
  buttonHover: {
    width : 36,
    height : 36,  
    margin : '0px 5px'     
},
iconHover: {
  cursor: 'pointer',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  fontSize: 24,
},  
modalImage: {
  position: 'absolute',
  width : '60%',
  paddingTop : '33.75%',
  height : 0,
  border : 'none',
  backgroundSize : 'cover',
  backgroundPosition : 'center',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
},
imageZoom : {
  width : '100%',
},
  });